export enum AutomationStatusType {
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
}
